<template>
  <div class="loading">
    <div class="img-box">
      <img :src="require('@/assets/images/loading.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
}
</script>
